import { FC } from 'react';
import { IEditUser, IUserRequest } from '../../model/IUser';
import { IZodErrorsState } from '../../utils/checkFormStateByZod';
import AgentRoleMultiSearchField from '../agent/AgentRoleMultiSearchField';
import { TInputEventHandle } from '../form/Input';
import UserRoleMultiSearchField from '../user/UserRoleMultiSearchField';
import VendorRoleMultiSearchField from '../vendor/VendorRoleMultiSearchField';
import VendorSelect from '../vendor/VendorSelect';

const UserEditRole: FC<{
  userState: IEditUser,
  handle: (key: keyof IEditUser) => TInputEventHandle,
  userErrState?: Partial<IZodErrorsState<IUserRequest>>,
  isPending: boolean,
  className?: string,
}> = ({
  userState,
  handle,
  userErrState,
  isPending,
  className = '',
}) => (
    <div className={`grid grid-cols-12 gap-x-8 gap-y-8 ${className}`}>
      <UserRoleMultiSearchField
        label="Roles"
        name="roles"
        placeholder='User role'
        value={userState.roles}
        handle={handle('roles')}
        className='col-span-12'
        error={userErrState?.roles}
        disabled={isPending}
      />

      {(userState?.roles || '').includes('ROLE_VENDOR') && (
        <>
          <VendorSelect
            label="Vendor"
            name="vendor"
            placeholder='Attach to Vendor'
            value={userState.vendor}
            handle={handle('vendor')}
            error={userErrState?.vendor}
            disabled={isPending}
            className="col-span-6"
          />
          {!!userState.vendor && (
            <VendorRoleMultiSearchField
              label="Vendor Role"
              name="vendorRole"
              placeholder='Role for Vendor'
              value={userState.vendorRole}
              handle={handle('vendorRole')}
              className='col-span-6'
              error={userErrState?.vendorRole}
              disabled={isPending}
            />
          )}
        </>
      )}

      {(userState?.roles || '').includes('ROLE_AGENT') && (
        <div className='col-span-12'>
          <AgentRoleMultiSearchField
            label="Agent Role"
            name="agentRole"
            placeholder='Role for Agent'
            value={userState.agentRole}
            handle={handle('agentRole')}
            error={userErrState?.agentRole}
            disabled={isPending}
          />
        </div>
      )}

    </div>
  );

export default UserEditRole;
